import { useContext } from 'react';
import { useMutation } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTrackerContext from 'automation-ui-usage-tracking/UsageTrackerContext';
import { trackEvent } from 'automation-ui-usage-tracking/trackingUtils';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import FeedbackForm from 'automation-ui-enrollment/components/aiAssistant/FeedbackForm';
import { AI_GENERATED_ACTIONS_FEEDBACK } from 'automation-ui-enrollment/components/aiAssistant/queries/opsHubAiQueries';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FeedbackFormForActions({
  aiPrompt,
  generationResponse,
  flowId
}) {
  const {
    usageTracker
  } = useContext(UsageTrackerContext);
  const [submitFeedback, {
    called,
    loading
  }] = useMutation(AI_GENERATED_ACTIONS_FEEDBACK);
  const handleSubmit = (rating, feedback) => {
    trackEvent(usageTracker, Trackables.RATE_GENERATED_ASSET, {
      aiPrompt,
      assetType: 'AI Generated Workflow Action',
      feedback,
      flowId,
      generationResponse: JSON.stringify(generationResponse),
      rating
    });
    if (generationResponse.correlationId) {
      submitFeedback({
        variables: {
          correlationId: generationResponse.correlationId,
          rating,
          feedback
        }
      }).catch(() => {});
    }
  };
  return /*#__PURE__*/_jsx(FeedbackForm, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.aiAssistantFeedbackFooter.ratingButtons.rateActions"
    }),
    isLoading: called && loading,
    onSubmit: handleSubmit
  }, generationResponse.correlationId);
}